import { decodeUrl } from "../../helperFunctions";
import { SingleCooperative } from "../../redux/features/cooperative/cooperative.type";

export const CooperativeProfilePic = ({
  cooperative,
  className = "",
}: {
  cooperative: SingleCooperative;
  className?: string;
}) => {
  const colors = ["!bg-[#F1D7FD] !border-[#F1D7FD]"];

  const randomColor = colors[Math.floor(Math.random() * colors.length)];

  return (
    <div
      className={`
        w-[72px] h-[72px]
        flex items-center justify-center
        ${
          !cooperative?.logo &&
          `text-[16px] font-bold uppercase !border ${randomColor}`
        }
        rounded-full overflow-hidden bg-light-purple/0
        border-[0.5px] border-pry-green-200/[0]
        ${className}
        `}
    >
      {cooperative?.logo ? (
        <img
          src={decodeUrl(cooperative?.logo)}
          alt="cooperative_logo"
          className="object-cover w-full h-full"
        />
      ) : (
        cooperative?.CoopName?.slice(0, 2)
      )}
    </div>
  );
};
